import { LockClosedIcon } from "@enkor/design/icons";
import { grayScale } from "@enkor/design/colors";

import * as S from "./CommentBlocker.style";

const CommentBlocker = () => {
  return (
    <S.Container>
      <LockClosedIcon strokeColor={grayScale.white} />
      <S.Phrase name="h6">
        {
          "Can unlock the conversation by joining the Enkoplay.\nEngage with fellow participants!"
        }
      </S.Phrase>
    </S.Container>
  );
};

export default CommentBlocker;
